import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import "streamdown/styles.css";
import { setupAxiosAuthInterceptor } from "./api/setupAxiosAuthInterceptor";

setupAxiosAuthInterceptor();
// Custom Cognito configuration
const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
